<template>
  <div >
    <portlet
            :actionsBlock="true"
            :icon="'fad fa-pencil'"
            :title="$t('instructions.editInstruction')"
    >
      <template slot="actionsBlock">
        <back-button :link="'instructions'"/>
      </template>
      <template slot="portletBody">
        <InstructionsForm :instruction="getInstructionById(this.$route.params.id)"></InstructionsForm>
      </template>
    </portlet>
  </div>
</template>

<script>
import InstructionsForm from '../../components/instructions/InstructionsForm';
import {mapGetters} from "vuex";
  export default {
    name: 'EditInstruction',
    components: {
      InstructionsForm
    },
    provide() {
      return {
        $validator: this.$validator
      };
    },
    computed: {
      ...mapGetters('instructions', ['getInstructionById'])
    }
  };
</script>
